// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "160c89e3bdded51a1f320a5f498d6925" + ".css";
};